import { useEffect, useCallback } from 'react';
import { useSearchParams, useBlocker } from 'react-router-dom';
import { useLocalStorage } from '@uidotdev/usehooks';
import { useGame } from 'common/state';

export function useModal() {
  const [searchParams, setSearchParams] = useSearchParams();

  const id = searchParams.get('open');

  const open = (newId) => {
    searchParams.set('open', newId);
    setSearchParams(searchParams);
  };

  const close = () => {
    searchParams.delete('open');
    setSearchParams(searchParams);
  };

  return { id, open, close };
}

export function useGameDataHistory() {
  const [gameDataHistory, setGameDataHistory] = useLocalStorage(
    'letroso-games-pt',
    {},
  );
  const [gameDataHistoryEN, setGameDataHistoryEN] = useLocalStorage(
    'letroso-games-en',
    {},
  );
  const [gameDataHistoryES, setGameDataHistoryES] = useLocalStorage(
    'letroso-games-es',
    {},
  );

  const getGameData = useCallback(
    (gameId, language) => {
      if (language === 'en') {
        return gameDataHistoryEN[gameId];
      }
      if (language === 'es') {
        return gameDataHistoryES[gameId];
      }
      return gameDataHistory[gameId];
    },
    [gameDataHistory, gameDataHistoryEN, gameDataHistoryES],
  );

  const updateGameData = useCallback(
    (gameState) => {
      const { id: gameId, data, language } = gameState;
      if (gameId === undefined || gameId === null || !data || !language) {
        return;
      }
      let selectedGameDataHistory = gameDataHistory;
      let selectedSetGameDataHistory = setGameDataHistory;
      if (language === 'en') {
        selectedGameDataHistory = gameDataHistoryEN;
        selectedSetGameDataHistory = setGameDataHistoryEN;
      } else if (language === 'es') {
        selectedGameDataHistory = gameDataHistoryES;
        selectedSetGameDataHistory = setGameDataHistoryES;
      }
      if (data) {
        const currentData = selectedGameDataHistory[gameId];
        if (JSON.stringify(currentData) !== JSON.stringify(data)) {
          selectedSetGameDataHistory({
            ...selectedGameDataHistory,
            [gameId]: data,
          });
        }
      }
    },
    [
      gameDataHistory,
      gameDataHistoryEN,
      gameDataHistoryES,
      setGameDataHistory,
      setGameDataHistoryEN,
      setGameDataHistoryES,
    ],
  );

  return { getGameData, updateGameData };
}

export function useNavigationBlocker() {
  const [gameState] = useGame();
  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      currentLocation.pathname !== nextLocation.pathname &&
      gameState.data.status !== 'selecting' &&
      gameState.data.status !== 'won',
  );

  useEffect(() => {
    if (blocker.state === 'blocked') {
      blocker.reset();
    }
  }, [blocker]);
}
